var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { MPInstancesHub } from "@/api/RequestAxios/RequestAxiosHub";
import { packQueryParams } from "../utils";
import { UIModelHubUser, UIModelHubUsers } from "./hubUser.model";
import { unpackHubUsers, unpackHubUser, packHubUser } from "./hubUser.mapper";
import { toJS } from "mobx";
import qs from "qs";
var partnerUsersURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/users");
};
var partnerUserUrl = function (_a) {
    var partnerId = _a.partnerId, userId = _a.userId;
    return "/partners/".concat(partnerId, "/users/").concat(userId);
};
var checkUserExistenceURL = function () { return "/public/check_email"; };
export var getUsers = function (partnerId, queryParams) { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(partnerUsersURL({ partnerId: partnerId }), {
                    params: queryParams && packQueryParams(queryParams),
                    paramsSerializer: function (params) {
                        var filters = params.filters, otherParams = __rest(params, ["filters"]);
                        var serializedQueryString = qs.stringify(otherParams, {
                            arrayFormat: "repeat",
                        });
                        return "".concat(serializedQueryString, "&filters=").concat(JSON.stringify(toJS(filters)));
                    },
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, new UIModelHubUsers(unpackHubUsers(data))];
        }
    });
}); };
export var getUser = function (_a) {
    var partnerId = _a.partnerId, userId = _a.userId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(partnerUserUrl({ partnerId: partnerId, userId: userId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelHubUser(unpackHubUser(data))];
            }
        });
    });
};
export var addUser = function (_a, payload) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(partnerUsersURL({ partnerId: partnerId }), packHubUser(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelHubUser(unpackHubUser(data))];
            }
        });
    });
};
export var updateUser = function (_a, payload) {
    var partnerId = _a.partnerId, userId = _a.userId;
    return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.patch(partnerUserUrl({ partnerId: partnerId, userId: userId }), payload)];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
};
export var deleteUser = function (_a) {
    var partnerId = _a.partnerId, userId = _a.userId;
    return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.delete(partnerUserUrl({ partnerId: partnerId, userId: userId }))];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
};
export var checkUser = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(checkUserExistenceURL(), payload)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
//# sourceMappingURL=data:application/json;base64,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